<template>
    <div class="infinite-scroll">
        <slot />
        <BaseLoader v-if="isLoading" />
        <BaseButton
            v-else-if="!disabled"
            ref="tracker"
            label="Meer laden"
            @click="emit('load-more')"
        />
    </div>
</template>

<script setup>
import { useElementVisibility } from '@vueuse/core';
import { useTemplateRef } from 'vue';

const props = defineProps({
    isLoading: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['load-more']);

const tracker = useTemplateRef('tracker');
const trackerIsVisible = useElementVisibility(tracker);

watch(() => trackerIsVisible.value, (newValue) => {
    if (newValue && !props.disabled) {
        emit('load-more');
    }
});
</script>

<style lang="less">

</style>
